import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { ILibraryWidget } from '../services/api/library/types';
import { __ } from './expressions';

type WidgetGrid = {
    category: string;
    widgets: ILibraryWidget[];
}[];

export const useWidgetLibraryStore = defineStore('widgetLibrary', () => {
    const widgets = ref<ILibraryWidget[]>([]);
    const filteredWidgets = ref<ILibraryWidget[]>([]);
    const categoryFilter = ref<Record<string, boolean>>({});
    const selectedWidget = ref<string>('');

    const setInitialWigets = (initialWidgets: ILibraryWidget[]) => {
        widgets.value = initialWidgets;
        widgets.value.forEach((widget) => {
            if (widget.category === null) {
                categoryFilter.value[__('library-uncategorized')] = true;
            } else if (!categoryFilter.value[widget.category]) {
                categoryFilter.value[widget.category] = true;
            }
        });
        filteredWidgets.value = initialWidgets;
    };

    const updateCategoryFilter = (category: string) => {
        categoryFilter.value[category] = !categoryFilter.value[category];
    };

    const resetFilters = () => {
        const initialFilter = categoryFilter.value;
        Object.keys(initialFilter).forEach((key) => {
            initialFilter[key] = true;
        });
        categoryFilter.value = initialFilter;
    };

    const filterWidgets = (searchString: string) => {
        if (!searchString) {
            filteredWidgets.value = widgets.value;
            return;
        }
        filteredWidgets.value = widgets.value.filter((widget) => {
            const matchesSearch = searchString
                ? widget.title.toLowerCase().includes(searchString.toLowerCase())
                : true;
            return matchesSearch;
        });
    };

    const widgetGrid = computed<WidgetGrid>(() => {
        const grid: WidgetGrid = [];
        const categories = Object.keys(categoryFilter.value).filter(
            (category) => categoryFilter.value[category]
        );
        categories.forEach((category) => {
            grid.push({
                category,
                widgets: filteredWidgets.value.filter((widget) => {
                    if (category === __('library-uncategorized')) {
                        return widget.category === null;
                    }
                    return widget.category === category;
                }),
            });
        });
        return grid;
    });

    const handleSelect = (id: string, selected: boolean) => {
        // if (selected) {
        //     selectedWidgets.value.push(id);
        // } else {
        //     const index = selectedWidgets.value.indexOf(id);
        //     if (index > -1) {
        //         selectedWidgets.value.splice(index, 1);
        //     }
        // }
        selectedWidget.value = selected ? id : '';
    };

    return {
        filteredWidgets,
        categoryFilter,
        widgetGrid,
        selectedWidget,
        handleSelect,
        setInitialWigets,
        updateCategoryFilter,
        resetFilters,
        filterWidgets,
    };
});
